import { DocumentConsignmentData } from 'generated/bffDocument/models';
import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';
import { CustomerMasterSourceType } from 'models/swagger/customerMasterSourceType';

export const api = {
  postDocumentConsignment: (url: string, request: DocumentConsignmentData): Promise<ExtendedAxiosResponse> =>
    apiClient.post(`${url}/document-consignment`, request, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        asyncCall: false,
      },
    }),

  getDocumentTemplateList: (url: string): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/document-templates`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        sourceSystem: 'ONE-CRM',
        isCrm: true,
        forceCheck: false,
      },
    }),

  getStaticDocumentList: (url: string): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/static-document/documents`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        forceCheck: false,
      },
    }),

  checkDocumentStatus: (url: string, processingStep: string, journalJobPk: string): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/document-consignment/${journalJobPk}/processing-status`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        processingStep,
      },
    }),
};
